import { MinimumCombination } from '../../../../core/picks/minimum-combination';
import { MinimumCombo } from '../result/minimum-combo';
import { PreCheckErrorMixin } from './pre-check-error';

export class MinimumComboPreCheckError extends PreCheckErrorMixin(MinimumCombo) {
    constructor(pickId: string, minimumCombo: MinimumCombination, resultCount: number) {
        super(pickId, minimumCombo as number, resultCount);
    }

    override readonly expectedCount: MinimumCombination;
    override readonly receivedResultCount: number;
}
